import type { DefaultProps } from '@deck.gl/core';
import type { ScatterplotLayerProps } from '@deck.gl/layers';
import { ScatterplotLayer } from '@deck.gl/layers';

import customFragmentShader from './fragment.glsl';

type _RoundedRectangleLayerProps = {
  cornerRadius?: number;
};

// Define the props type that extends ScatterplotLayerProps
export type RoundedRectangleLayerProps<DataT = unknown> = _RoundedRectangleLayerProps & ScatterplotLayerProps<DataT>;

const defaultProps: DefaultProps<RoundedRectangleLayerProps> = {
  // cornerRadius: the amount of rounding at the rectangle corners
  // 0 - rectangle. 1 - circle.
  ...ScatterplotLayer.defaultProps,
  cornerRadius: { type: 'number', value: 0.1 }, // Define cornerRadius with type and default value
};

// Create the custom layer class
export default class RoundedRectangleLayer<DataT = unknown> extends ScatterplotLayer<
  DataT,
  _RoundedRectangleLayerProps
> {
  static layerName = 'RoundedRectangleLayer';
  static defaultProps = defaultProps;
  // Override the draw method
  draw({ uniforms }: { uniforms: unknown[] }) {
    super.draw({
      uniforms: {
        ...uniforms,
        cornerRadius: this.props.cornerRadius,
      },
    });
  }

  // Override the getShaders method
  getShaders() {
    return Object.assign({}, super.getShaders(), {
      fs: customFragmentShader, // Custom fragment shader
    });
  }
}
